import React, { useState } from 'react';
import agent from '../api/agent';
import { LoadingOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { message, Tooltip } from 'antd';
import { handleError } from '../common/utils';

const UploadIncomingVendorInvoices = ({ packageId, savedInvoices, callback }) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [invoicesToSave, setInvoicesToSave] = useState([]);

  const handleFileChange = (e) => {
    setInvoicesToSave([...invoicesToSave, ...e.target.files]);
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = [...invoicesToSave];
    updatedFiles.splice(index, 1);
    setInvoicesToSave(updatedFiles);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('packageId', packageId);
      invoicesToSave.forEach((file) => formData.append('files', file));

      await agent.pkg.uploadInvoices({ packageId, files: invoicesToSave });
      message.success('Upload successful!');
      setInvoicesToSave([]);
      handleClose();
    } catch (e) {
      handleError(e);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setInvoicesToSave([]);
    setShowModal(false);
    callback?.();
  };

  const handleDeleteInvoice = async (packageInvoiceId) => {
    try {
      await agent.pkg.deleteInvoice({ packageInvoiceId });
      message.success('Invoice deleted successfully!');
      callback?.();
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <>
      <button className="btn" onClick={() => setShowModal(true)}>
        Upload Invoices
        <Tooltip title="For shipments from the US to Canada, upload your receipts and enter the vendor's name to unlock additional discounted shipping options at checkout.">
          <InfoCircleOutlined style={{ marginLeft: '8px', fontSize: '16px' }} />
        </Tooltip>
      </button>

      {showModal && (
        <div className="global-overlay">
          <div className="global-overlay-tapcapture global-overlay-tapcapture-grey" onClick={handleClose} />
          <div className="global-overlay-modal package-request-form">
            <div className="flex justify-between items-center mb-4">
              <h2 className="package-request-title">Upload Invoices</h2>
              <button className="icon btn-icon" onClick={handleClose}>
                <svg className="feather feather-black">
                  <use href="/assets/images/icons/feather-sprite.svg#x" />
                </svg>
              </button>
            </div>

            {savedInvoices.length > 0 && (
              <div className="mb-4">
                {savedInvoices.map(({ packageInvoiceId, url, fileName }) => (
                  <div key={packageInvoiceId} className="package-details-item flex justify-between items-center">
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {fileName}
                    </a>
                    <button
                      className="package-item-icon-col btn-icon ml-2"
                      onClick={() => handleDeleteInvoice(packageInvoiceId)}
                    >
                      <svg className="feather">
                        <use href="/assets/images/icons/feather-sprite.svg#trash-2" />
                      </svg>
                    </button>
                  </div>
                ))}
              </div>
            )}

            <div className="mb-4">
              <input
                type="file"
                multiple
                accept=".pdf,.png,.jpg,.jpeg,.doc,.docx"
                onChange={handleFileChange}
                className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
              />
            </div>

            {invoicesToSave.length > 0 && (
              <div className="mb-4">
                {invoicesToSave.map((file, index) => (
                  <div key={index} className="flex justify-between items-center bg-gray-100 rounded-lg p-2 mb-2">
                    <span>{file.name} ({(file.size / 1024).toFixed(2)} KB)</span>
                    <button
                      className="package-item-icon-col btn-icon ml-2"
                      onClick={() => handleRemoveFile(index)}
                    >
                      <svg className="feather">
                        <use href="/assets/images/icons/feather-sprite.svg#trash-2" />
                      </svg>
                    </button>
                  </div>
                ))}
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', padding: '5px 0 0 0' }}>
              <button
                type="button"
                className="btn w-full"
                onClick={handleSubmit}
                disabled={loading || invoicesToSave.length === 0}
                style={{ cursor: loading || invoicesToSave.length === 0 ? 'not-allowed' : 'pointer' }}
              >
                {loading ? <LoadingOutlined spin /> : 'Upload'}
              </button>
              <button 
              type="button" className="btn w-full" onClick={handleClose}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UploadIncomingVendorInvoices;
